import MyLink from '../../components/MyLink';
const AllNews = {
    "2025": [   
        {
            "date": "Aug. 2025",
            "content": <> 🎙️ Honored to give a talk at <MyLink href="https://events.humanitix.com/ai4good-2025">AI for Climate, Safety and Environment Workshop</MyLink> on "From Design Prototype to Code". </>
        },
        {
            "date": "July. 2025",
            "content": <> 🎓 I have been conferred a Ph.D. from Monash University. </>
        },
        {
            "date": "June. 2025",
            "content": <> ✨ I've begun a new chapter hosted at ANU for CSIRO's project, where I'm working with <MyLink href="https://people.csiro.au/X/Z/Zhenchang-Xing/">Prof. Zhenchang Xing</MyLink> and <MyLink href="https://zheng-lab-anu.github.io/index.html"> Prof. Liang Zheng</MyLink> on research related to Trustworthy LLM Generation!</>
        },
        {
            "date": "May. 2025",
            "content": <> ✨ I would serve on the Artifact Evaluation Program Committee for <MyLink href="https://ifm2025.ens.psl.eu/"> 20th edition of the International Conference on Integrated Formal Methods (iFM 2025)</MyLink>! Looking forward to your high-quality submissions!</>
        },
        {
            "date": "Apr. 2025",
            "content": <> ✨ I would serve on the Program Committee for <MyLink href="https://issre.github.io/2025/index.html">the 36th IEEE International Symposium on Software Reliability Engineering (ISSRE 2025)</MyLink>! Looking forward to your high-quality submissions!</>
        },
        {
            "date": "Apr. 2025",
            "content": <> ✨ I would serve on the Program Committee for <MyLink href="https://sites.google.com/view/quatic2025/thematic-tracks/safety-security-and-privacy?authuser=0">Security and Privacy (SP) Track</MyLink> at <MyLink href="https://sites.google.com/view/quatic2025/home?authuser=0">the 18th International Conference on the Quality of Information and Communications Technology (QUATIC 2025)</MyLink>! Looking forward to your high-quality submissions!</>
        },
        {
            "date": "Apr. 2025",
            "content": <>🥳 Our paper, "A Comparative Study between Android Phone and TV Apps" was accepted to ASEJ!</>
        },
        {
            "date": "Mar. 2025",
            "content": <> 🎙️ Honored to be invited to the Prof. <MyLink href="https://zheng-lab-anu.github.io/index.html">Liang Zheng</MyLink>'s CV group @ Australian National University for a talk on “From Program Analysis to Large Language Models for Software Engineering“.</>
        },
        {
            "date": "Mar. 2025",
            "content": <> ✨ I would serve on the Program Committee for  <MyLink href="https://llmappworkshop.github.io/">LLMapp 2025</MyLink>! Looking forward to your high-quality submissions about Large Language Model App Store Analysis!</>
        },
        {
            "date": "Feb. 2025",
            "content": <> ✨ I would serve on the Program Committee for  <MyLink href="https://llmsc.github.io/">LLMSC 2025</MyLink>! Looking forward to your high-quality submissions about Large Language Model Supply Chain Analysis!</>
        },
        {
            "date": "Jan. 2025",
            "content": <>🔍 Glad to serve on the Program Committee for  <MyLink href="https://pldi25.sigplan.org/">PLDI 2025</MyLink> Research Artifacts! Looking forward to your high-quality submissions!</>
        }
    ],
    "2024": [        
        {
            "date": "Nov. 2024",
            "content": <>🥳 Our paper, "LLM for Mobile An Initial Roadmap.” was accepted to TOSEM! Congrats to Daihang!</>
        },
        {
            "date": "Oct. 2024",
            "content": <>🇨🇳 I would attend CCF ChinaSoft2024, presenting our research on, "A Comparative Study between Android Phone and TV Apps"! See you in Xi An!</>
        },
        {
            "date": "Sep. 2024",
            "content": <>🇸🇬 I started a 6-month visiting research stay at the <MyLink href="https://soarsmu.github.io/">SOAR lab</MyLink> of the Singapore Management University with <MyLink href="http://www.mysmu.edu/faculty/davidlo/">Prof. Dr. David Lo</MyLink> in Singapoure (SG)!</>
        },
        {
            "date": "Sep. 2024",
            "content": <>🥳 Our paper, "Demystifying React Native Android Apps for Static Analysis" was accepted to TOSEM!</>
        },
        {
            "date": "June. 2024",
            "content": <>🇩🇰 I would attend PLDI 2024 in Copenhagen! Looking forward to meeting you there!</>
        },
        {
            "date": "May. 2024",
            "content": <>🇱🇺 I started a 3-month visiting research stay at the <MyLink href="https://soarsmu.github.io/">TruX lab</MyLink> of the University of Luxembourg with <MyLink href="https://jacquesklein2302.github.io/">Prof. Dr. Jacques Klein</MyLink>, <MyLink href="https://bissyande.github.io/">Prof. Dr. Tegawendé F. Bissyandé</MyLink>, and <MyLink href="https://www.jordansamhi.com/">Dr. Jordan Samhi</MyLink> in Luxembourg (LUX)!</>
        },
        {
            "date": "May. 2024",
            "content": <>🥳 Our paper, "Automatically Recommend Code Updates: Are We There Yet?", was accepted to TOSEM!</>
        },
        {
            "date": "May. 2024",
            "content": <>🥳 Our paper “LLM for Mobile An Initial Roadmap”, has been invited to be presented on ACM TOSEM SE2030 Special Issue!</>
        },
    ],
}

export default AllNews
